"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarUserMenu = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const index_1 = require("@ant-design/icons/es/icons/index");
const react_router_dom_1 = require("react-router-dom");
const AppRouter_1 = require("src/configeek_assets/src/components/common/AppRouter");
const lodash_1 = __importDefault(require("lodash"));
const ProjectsDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectsDataProvider");
const TextTruncated_1 = require("src/configeek_assets/src/components/common/widget/TextTruncated");
const CurrentPageProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentPageProvider");
const appICUtils_1 = require("src/configeek_assets/src/ic/appICUtils");
const geekfactory_ic_js_auth_1 = require("geekfactory-ic-js-auth");
const MenuKeys = {
    profile: "profile",
    members: "members",
    projects: "projects",
    legal: "legal",
    logout: "logout",
};
const ToolbarUserMenu = () => {
    const authProviderContext = (0, geekfactory_ic_js_auth_1.useAuthProviderContext)();
    const projectsDataContext = (0, ProjectsDataProvider_1.useProjectsDataContext)();
    const { page } = (0, CurrentPageProvider_1.useCurrentPageContext)();
    const projectApiKeyInUrl = page.identifier === "project" ? page.projectApiKey : undefined;
    const currentProjectData = projectsDataContext.getProject(projectApiKeyInUrl);
    const handleLogout = (0, react_1.useCallback)(async () => {
        antd_1.Modal.confirm({
            visible: true,
            title: "Log Out",
            icon: null,
            content: React.createElement(React.Fragment, null, "Are you sure you want to log out?"),
            onOk: () => {
                return authProviderContext.logout(authProviderContext.source);
            },
            okButtonProps: {
                danger: true
            },
            autoFocusButton: null
        });
    }, []);
    const hideMembersItem = currentProjectData == undefined || !appICUtils_1.ParticipantUtils.hasProjectMemberAccess(currentProjectData.view.participant);
    const items = lodash_1.default.compact([
        {
            type: "group",
            label: "My Profile",
            children: [{
                    "key": MenuKeys.profile,
                    label: React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PATH__PROFILE }, "Profile")
                }],
        },
        hideMembersItem ? undefined : { type: "divider" },
        hideMembersItem ? undefined : {
            type: "group",
            label: React.createElement(TextTruncated_1.TextTruncated, { text: currentProjectData.view.project.projectName, length: 40 }),
            children: [{
                    "key": MenuKeys.members,
                    label: React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PathGenerator.project(currentProjectData.view.project.projectApiKey, "members") }, "Members")
                }],
        },
        { type: "divider" },
        {
            "key": MenuKeys.projects,
            label: React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PATH__PROJECTS }, "Projects")
        },
        { type: "divider" },
        {
            "key": MenuKeys.legal,
            label: React.createElement(react_router_dom_1.Link, { to: AppRouter_1.PATH__LEGAL }, "Terms of Service")
        },
        { type: "divider" },
        {
            key: MenuKeys.logout,
            label: React.createElement("button", { onClick: handleLogout, className: "ug-text ug-text-full-width" }, "Log Out")
        }
    ]);
    const menu = React.createElement(antd_1.Menu, { style: { minWidth: "200px" }, items: items });
    return React.createElement(antd_1.Dropdown, { overlay: menu, trigger: ["click"], placement: "bottomRight" },
        React.createElement(antd_1.Avatar, { size: 32, icon: React.createElement(index_1.SettingOutlined, null), className: "userMenu" }));
};
exports.ToolbarUserMenu = ToolbarUserMenu;
